/**
 * Navigation utility functions for common navigation patterns
 */

/**
 * Navigate to the Settings page with billing tab
 * @param {Object} router - Vue Router instance (required)
 * @param {Object} options - Navigation options
 * @param {string} options.actionType - Alternative action type to use as query param (e.g., 'openPayment')
 * @param {string|null} options.hash - Hash fragment (default: '#manage-plan', set to hash to override default hash)
 * @param {Object} options.query - Additional query parameters to merge
 */
export function goToPlans(router, options = {}) {
    if (!router) {
        console.error('Navigation utility: router instance is required');
        return;
    }

    const query = { tab: 'billing', ...options.query };

    // Handle actionType or openPayment
    if (options.actionType) {
        query[options.actionType] = 'true';
    }

    const routeConfig = {
        name: 'Settings',
        query,
    };

    routeConfig.hash = '#manage-plan';

    if (options.hash) {
        routeConfig.hash = options.hash;
    }

    router.push(routeConfig);
}

